/* Tiloli hero slideshow. */
class TiloliHero extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-hero-slide]')];
    this.dots = [...this.querySelectorAll('[data-hero-dot]')];
    if (this.slides.length < 2) return;
    this.index = 0;
    this.timer = null;

    this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
    this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
    this.dots.forEach((d) => d.addEventListener('click', () => this.go(parseInt(d.getAttribute('data-hero-dot'), 10), true)));

    if (this.dataset.autoplay === 'true') {
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.start();
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
    }

    // touch swipe
    let x0 = null;
    this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    this.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
      x0 = null;
    }, { passive: true });
  }

  disconnectedCallback() { this.stop(); }

  go(i, userAction) {
    const n = this.slides.length;
    this.index = ((i % n) + n) % n;
    this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.index));
    this.dots.forEach((d, k) => d.classList.toggle('is-active', k === this.index));
    if (userAction && this.timer) { this.stop(); this.start(); }
  }

  start() { if (this.interval) this.timer = setInterval(() => this.go(this.index + 1), this.interval); }
  stop() { clearInterval(this.timer); this.timer = null; }
}
customElements.define('tiloli-hero', TiloliHero);
